import { NavLink } from "react-router-dom";
import FooterInstagramIcon from "../../../assets/images/footer/footer-instagramicon.png";
import FooterLogo from "../../../assets/images/footer/footer-logo.png";
import FooterYoutubeIcon from "../../../assets/images/footer/footer-youtubeicon.png";
import Icon from "../../Icon";
import * as S from "./styled";

const Footer = () => (
  <S.FooterComponent>
    <div className="inner">
      <S.FooterContentWrap>
        <S.FooterLocationListWrap>
          <h6>넵튠 댄스 스튜디오</h6>
          <p>
            서울 동작구 사당로16길 28 3층
            <br />
            Tel 010-2351-8784
          </p>
          <p>학원 등록번호: 제 4095호</p>
        </S.FooterLocationListWrap>
        <S.FooterInfoWrap>
          <p>국제실용댄스지도자협회 서울본부</p>
          <NavLink to="http://ipdiakorea.com/" target="_blank">
            <Icon>
              <img src={FooterLogo} alt="logo" />
            </Icon>
          </NavLink>
        </S.FooterInfoWrap>
      </S.FooterContentWrap>
      <S.FooterIconListWrap>
        <li>
          <NavLink to="https://www.instagram.com/neptuneseoul" target="_blank">
            <img src={FooterInstagramIcon} alt="logo" />
          </NavLink>
        </li>
        <li>
          <NavLink
            to="https://youtube.com/@neptunedance?si=FmEJVLzMbkuuIDNX"
            target="_blank"
          >
            <img src={FooterYoutubeIcon} alt="logo" />
          </NavLink>
        </li>
      </S.FooterIconListWrap>
      <S.FooterCopyText>
        © 2024 NEPTUNE DANCE STUDIO. All Rights Reserved.
      </S.FooterCopyText>
    </div>
  </S.FooterComponent>
);

export default Footer;
